import '@/assets/less/styles.less';
import { DefaultLayout } from './layouts/default-layout';
import { SideBar } from './core/components/SideBar';
import { NotificationsContextProvider } from './core/components/NotificationsContext';
import { UiFeature } from './feature';
import { useAppConfigContext } from './core';
import { useGetPageSubtitle, useGetPageTitle } from './store';
import { AppFooter as Footer } from '@/app/core/components/Footer';
import {
  MainNav,
  MainNavContext,
  MainNavState,
  NavItem,
} from '@/app/core/components/main-nav';
import { LightLogo } from '@/app/core/components/LightLogo';
import { GeneralNav } from '@/app/core/components/GeneralNav';
import { ReactNode, useEffect, useMemo, useState } from 'react';

export type AppLayoutProps = {
  feature: UiFeature;
  children?: ReactNode;
};
export const AppLayout = (props: AppLayoutProps) => {
  const { children, feature } = props;
  const { setCurrentFeatureCode } = useAppConfigContext();
  const pageTitle = useGetPageTitle();
  const pageSubtitle = useGetPageSubtitle();
  useEffect(() => {
    const title = `${pageTitle}${pageSubtitle ? ' - ' + pageSubtitle : ''}`;
    document.title = title;
  }, [pageTitle, pageSubtitle]);
  useEffect(() => {
    setCurrentFeatureCode(feature.code);
  }, [feature.code, setCurrentFeatureCode]);

  const [navItems, setNavItems] = useState<NavItem[]>([]);
  const mainNavState: MainNavState = useMemo(() => {
    return {
      setNavItems,
      navItems,
    };
  }, [navItems]);

  return (
    <NotificationsContextProvider>
      <MainNavContext value={mainNavState}>
        <DefaultLayout
          footer={<Footer />}
          mainNav={
            <SideBar>
              <MainNav />
            </SideBar>
          }
          generalNav={<GeneralNav />}
          logo={<LightLogo title={feature.name} />}
        >
          {children}
        </DefaultLayout>
      </MainNavContext>
    </NotificationsContextProvider>
  );
};
